import React, { useState,useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Button } from 'semantic-ui-react';
import AnimateHeight from 'react-animate-height';
import {Paper } from '@material-ui/core';
import {Typography } from '@material-ui/core';
import { Link } from 'react-router-dom'
import Axios from 'axios'
import moment from 'moment';
import Rodal from 'rodal';
import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";


import config from '../../../app/api/apiconfig';

const schedulingbaseUrl = config.app.schedulingbaseUrl
const thisbooknewappturl = config.app.booknewapptUrl



const useStyles = makeStyles((theme) => ({   
    slotDiv: {
        margin: "0 auto",
        height: "150px",
        lineHeight: "150px",
        width: "300px",
        textAlign: "center",
        backgroundColor: "black",
        display: "flex",
    flexDirection: "column",
    justifyContent: "center"

      
    },
      Typog: {
        fontWeight: "bold",
        cursor: "pointer",
        paddingTop: "25px",

        
    },
    Paper: {
        backgroundColor: "#90ee90",
        textAlign: "center",
        cursor: "pointer",
        height: "70px",
        lineHeight: "70px",
        verticalAlign: "middle"


    },
    PaperLight: {
        backgroundColor: "#c9fec9",
        textAlign: "center",
        cursor: "pointer",
        height: "70px",
        lineHeight: "70px",
        verticalAlign: "middle"
    },
    Link: {
        width: "100%",
        height: "100%",
        textDecoration: "none",
        color: "black",
        padding: "5px",
        fontWeight: "bold",
        textAlign: "center",
        margin: "0 auto",
       
       },
       P: {
           verticalAlign: "middle",
           
       }
    }));

export default function Slot(props) {

const [booked,setBooked] = useState(false)

const [failed, setFailed] = React.useState(false);

//ADD220610 - for avoiding doubleclick 
const [loadhold, setLoadhold] = useState(false)
const [errors, setErrors] = useState(false)
//


    function bookAppointment(){
        var bookingStatus = "f16d80d1-fd07-4237-8b69-187a11eb75f9"
        var setresourceid = props.resourcedata.ResourceID
        //ADD220616 - fix for only testing about resource unavailable issue
        console.log("config.environment::",config.environment)
        if (config.environment === 'test') {
          console.log("props.resourcedata.ResourceID::",props.resourcedata.ResourceID)
          if (props.resourcedata.ResourceID === '9815777f-6bb7-e811-a969-00224807251a' || props.resourcedata.ResourceID === '9136ea56-69b7-e811-a969-00224807251a'){
            setresourceid = "9b4c72bb-641f-ec11-b6e6-000d3ad67e26"
          } else {
            setresourceid = "9b4c72bb-641f-ec11-b6e6-000d3ad67e26"
          }
        }
        //

        const bookingRequest = {
          workorderId: props.jobdata.workorderId, resourceId: setresourceid, bookingStatusId: bookingStatus, slotStart: props.resourcedata.Start, duration: 60, start: props.resourcedata.Start,end:props.resourcedata.End
      }      

    //   http://localhost:59104/
      //Axios.post("https://lookaheadintegrationapi.azurewebsites.net/api/scheduling/booknewappointment",bookingRequest)
      Axios.post(thisbooknewappturl, bookingRequest)
      .then(response => {
        console.log(response)
        if (response.status === 200){
            setLoadhold(false)
            setBooked(true)
        } else {
            setLoadhold(false)
            setFailed(true)
          }
      })
      .catch((error) =>{
        if (error.response) {
            console.log(error.response)
            setLoadhold(false)
            setErrors(true)
        }
      })
    }
  
    function handleClick(){

          var answer = window.confirm("Are you sure you would like to book this job?")
          if(answer){
            setLoadhold(true)
              bookAppointment();
          }   
    }

    const classes = useStyles();

      const hideModal = () => {
        setBooked(false);
        setLoadhold(false);
      };

      const hideErrorModal = () => {
        setErrors(false);
      }; 

      //reload availability after booking success
      const hideSuccessModal = () => {
        setBooked(false);
        window.location.href = "/lookaheadjobs";
        setLoadhold(false);
      };

      //ADD220610 - for checking slot and targetdate 
      //Check if slot start after the job targetdate
    let thisslotstart = moment(props.startTime);
  let thisslottarget = moment(props.jobdata.TargetDate);
  const isAfterTarget = thisslotstart.isAfter(thisslottarget);
  console.log(isAfterTarget);
  console.log(thisslotstart.format('DD/MM HH:mm'), "<->", thisslottarget.format('DD/MM HH:mm'));

  let classused = classes.Paper;
  // if slot start after the job targetdate, use lighter background
  if (isAfterTarget) {
      classused = classes.PaperLight;
  }

  // ADD240118 - check if slotstart is odd (daytimesaving) for slottext
  let slotactualstart = (moment(props.startTime).hours() % 2 === 0) ? moment(props.startTime) : moment(props.startTime).add(60, 'minutes');
  let slotactualend = (moment(props.endTime).hours() % 2 === 0) ? moment(props.endTime) : moment(props.endTime).add(60, 'minutes');

  // Function to determine if a time is AM or PM
  function getPeriod(momentTime) {
      const hour = momentTime.hours();
      if (hour >= 8 && hour < 13) {
          return 'AM';
      } else if (hour >= 13 && hour < 17) {
          return 'PM';
      }
      return ''; // Return empty if the time is out of defined range
  }

  // ADD220808 - for showing AM/PM at slot only
  let slottext = slotactualstart.format('DD/MM') + ' ' + getPeriod(slotactualstart);

  console.log(slottext); // Debugging line to see the output

      
      //
    return (
        <>
        <Paper onClick={handleClick} className={classused}>
                <p className={classes.Typog}>
                     { slottext } 
                </p>
        </Paper>

        <Modal show={loadhold}>
        <Modal.Body>Submitting the selected slot, please wait....</Modal.Body>
        </Modal>

        <Modal show={errors} onHide={hideErrorModal}>
        <Modal.Body>Errors occurred when submitting, please retry later</Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={hideErrorModal}>
                Close
            </Button>
            </Modal.Footer>
        </Modal>

            <Modal show={booked} onHide={hideSuccessModal}>

            <Modal.Body>The Slot has been booked successfully</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={hideSuccessModal}>
                Close
                </Button>
            </Modal.Footer>
            </Modal>

            <Modal show={failed} onHide={hideModal}>

            <Modal.Body>Slot Failed to be booked</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={hideModal}>
                Close
                </Button>
            </Modal.Footer>
            </Modal>
     </>
    )
}
